import React from "react";
import "./Skills.css";
import SkillCard from "../SkillCard/SkillCard";

const skillCategories = [
  {
    title: "Security",
    skills: [
      { name: "Penetration Testing", level: 75 },
      { name: "Network Security", level: 78 },
      { name: "Web Vulnerabilities (XSS, IDOR, SSRF, SQLi)", level: 72 },
      { name: "Security Auditing", level: 70 },
      { name: "Incident Response", level: 68 },
      { name: "Bug Bounty Methodology", level: 65 },
    ],
  },
  {
    title: "Development",
    skills: [
      { name: "Python", level: 90 },
      { name: "PHP", level: 85 },
      { name: "Laravel", level: 82 },
      { name: "JavaScript", level: 80 },
      { name: "C", level: 78 },
      { name: "C++", level: 75 },
      { name: "MySQL", level: 80 },
      { name: "SQLite", level: 78 },
      { name: "HTML & CSS", level: 80 },
    ],
  },
  {
    title: "Infrastructure & Automation",
    skills: [
      { name: "Linux Systems", level: 82 },
      { name: "Network Architecture", level: 75 },
      { name: "Docker", level: 68 },
      { name: "AWS/Cloud Basics", level: 60 },
      { name: "Python Security Automation", level: 85 },
      { name: "Socket Programming", level: 78 },
    ],
  },
];


const Skills = () => {
  return (
    <section id="skills" className="skills-section">
      <h2 className="skills-section-title">Technical Expertise</h2>
      <div className="skills-tree-container">
        <div className="skills-tree-center">MY SKILLS</div>
        <div className="skills-tree-branches">
          {skillCategories.map((cat, i) => (
            <div className="skills-tree-category" key={cat.title}>
              <div className="skills-tree-category-title">{cat.title}</div>
              <div className="skills-tree-skills">
                {cat.skills.map((skill) => (
                  <SkillCard name={skill.name} level={skill.level} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
